export default __webpack_public_path__ + "static/media/eye.c561dff2.svg";